export default "__VITE_ASSET__CcJxFOx4__"